/* iter55f87 — "Powered by Emergent" script line.
 *
 * A small, self-contained badge appended to the bottom of the various
 * landing/marketing surfaces. Keeps the credit line consistent (font,
 * spacing, opacity) so we can restyle it in one place if the branding
 * ever changes again.
 *
 * Deliberately unobtrusive: italic display face, muted opacity, no
 * link decoration — this is a credit, not a CTA.
 */
import React from 'react';

export default function PoweredByEmergent({
  className = '',
  align = 'center',
  testId = 'powered-by-emergent',
}) {
  const alignCls =
    align === 'center' ? 'text-center' :
    align === 'right'  ? 'text-right'  :
                          'text-left';
  return (
    <div
      className={`mt-2 ${alignCls} ${className}`}
      data-testid={testId}
    >
      <span
        className="inline-flex select-none items-center gap-1 text-[10px] italic tracking-wide opacity-60"
        style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}
      >
        <span aria-hidden>·</span>
        Powered by&nbsp;<em>Emergent</em>
        <span aria-hidden>·</span>
      </span>
    </div>
  );
}
